import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-4">
          <div className="max-w-md w-full">
            <div className="card text-center">
              <FontAwesomeIcon
                icon={faTriangleExclamation}
                className="text-6xl text-red-500 mb-4"
              />
              <h1 className="text-2xl font-bold text-neutral-900 mb-2">
                Något gick fel
              </h1>
              <p className="text-neutral-600 mb-6">
                Ett oväntat fel uppstod. Vi ber om ursäkt för besväret.
              </p>
              <button
                onClick={() => window.location.href = '/'}
                className="btn-primary"
              >
                Tillbaka till startsidan
              </button>
              {process.env.NODE_ENV === 'development' && this.state.error && (
                <div className="mt-6 text-left">
                  <details className="text-sm">
                    <summary className="cursor-pointer text-neutral-700 font-semibold mb-2">
                      Teknisk information (endast i utvecklingsläge)
                    </summary>
                    <pre className="bg-neutral-100 p-4 rounded overflow-auto text-xs">
                      {this.state.error.toString()}
                      {this.state.errorInfo && this.state.errorInfo.componentStack}
                    </pre>
                  </details>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
